import { Divider, Stack } from '@chakra-ui/react';
import { Services } from './components/Services';
// import { GiftCards } from './components/GiftCards';

function Prices() {
  return (
    <Stack spacing={10}>
      <Services />
      <Divider />
      {/* <GiftCards /> */}
    </Stack>
  );
}

export { Prices };
